exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".countdown {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n  .countdown .measurements {\n    flex: 0.1; }\n    .countdown .measurements .divider {\n      float: right; }\n", ""]);

